// @ts-ignore
import { CredifyClass } from "./common";
import { OnboardingApiFactory } from "@credify/api-docs/apiClients/v2/api/onboarding-api"
import { Phone } from "@credify/api-docs/apiClients/integration-v2";
import { CreateIndividualDOPRequest } from "@credify/api-docs/apiClients/v2/model";
import { handleAPIConfiguration } from "./utils";

export class Entity extends CredifyClass {
  // the code function is not working due to incorrect access token. will fix later
  public async sendOtpViaSms(
    phoneNumber: string,
    countryCode: string
  ): Promise<any> {
    try {
      const configuration = handleAPIConfiguration(this.config.mode)
      const client = OnboardingApiFactory(configuration, "", this.apiClient.instance as any)
      const phone: Phone = {
        phoneNumber: phoneNumber,
        countryCode: countryCode
      }
      const res = await client.sendOtpSms(phone)
      return res
    } catch(error) {
      throw error
    }
  }

  public async createIndividual(
    phoneNumber: string,
    countryCode: string,
    code: string,
    signingKey: string
  ): Promise<any> {
    try {
      const configuration = handleAPIConfiguration(this.config.mode)
      const client = OnboardingApiFactory(configuration, "", this.apiClient.instance as any)
      const phone: Phone = {
        phoneNumber: phoneNumber,
        countryCode: countryCode
      }
      const request: CreateIndividualDOPRequest = {
        phone: phone,
        code: code,
        signingPublicKey: signingKey
      }
      const res = await client.createIndividualEntityForDop(request)
      return res.data
    } catch(error) {
      const e = error
      throw(error)
    }
  }
}
